import 'babel-polyfill';
import './styles.less';
import 'bootstrap/dist/js/bootstrap.min.js';
import React from 'react';
import ReactDOM from 'react-dom';
import { App, Search, Resumes, Filters, Details } from 'app';
import { ActiveResumeStore, Creators, ResumeStore } from 'model';
import { Router, Route, Link, Config, setup, action, Modal, Header, Body, _ } from 'utils';
import moment from 'moment/src/moment';
import 'moment/src/locale/en-gb';
import 'moment/src/locale/hr';
import { Credits } from 'subscription';
import { Latest, MoveToCampaign, EditCampaign, DeleteCampaign, AddCampaign, CreateForUser  } from 'campaign';
import { PageTitle, CampaignSelector, Move, Page, LatestResumes, DbPanel, EqFilters, NoCredits, SideBox } from 'app';
import "../node_modules/font-awesome/scss/font-awesome.scss";
import {reloadLanguages} from "./modules/model/Creators";

function PageSearch({ buyUrl }) {

	let ready = ResumeStore.getState().ready;

	if(ready == false) {
		Creators.reloadResumes();
	}

	Creators.reloadLatestResumes();
	Creators.reloadCredits();

	var sidebar = '';

	if(Config.sidebar) {
		sidebar = <div className="col-md-4">
			<Credits buyUrl={buyUrl} />
			<Latest />
			<LatestResumes />
		</div>;
	} else {
		sidebar = (
			<div className="col-md-4">
				<SideBox buyUrl={buyUrl} />
			</div>
		);
	}

	return <Page name="search">

		<PageTitle />

		<div className="row">
			<div className="col-md-12 db-search">

			</div>
			<div className="col-md-8">
				<Search store="any" description={_("Koga tražite")} filterDescription={_("Vrste filtera")} />
				<Resumes />
			</div>
			{ sidebar }
		</div>

	</Page>;
}

function bootstrap(config) {
	setup(config);
	moment.locale(config.locale);
}

export function loadPanel(config) {

	bootstrap(config);

	Creators.reloadAds();
	Creators.reloadCredits();

	ReactDOM.render(<DbPanel />, document.getElementById(config.container));
}

export function start(config) {
	bootstrap(config);

	//Creators.reloadResumes();
	Creators.reloadQualifications();
	Creators.reloadJobTypes();
	Creators.reloadAds();
	Creators.reloadCredits();
	Creators.reloadLanguages();

	var view = <Router>
		<div>
			<Route
				exact
				path={config.baseUrl}
				component={() => {

					return (
						<PageSearch buyUrl={config.buyUrl} />
					);
				}}
			/>
			<Route
				path={ config.baseUrl + "resume/:resumeId" }
				component={({ match }) => {
					return (
						<Details
							id={match.params.resumeId}
							buyUrl={config.buyUrl}
						/>
					);
				}}
			/>
		</div>
	</Router>;

	ReactDOM.render(view, document.getElementById(config.container));

	var modals = <div>
		<Modal show="show-no-credits" hide="hide-no-credits" className="no-credits">
			<Header title={_('Iskoristite pune mogućnosti baze životopisa')} />
			<Body><NoCredits buyUrl={config.buyUrl} /></Body>
		</Modal>

		<Modal show="show-filters" hide="hide-filters" className="filters">
			<Header title={_('Filteri')} />
			<Body><EqFilters /></Body>
		</Modal>

		<Modal show="show-folders" hide="hide-folders" className="new-folder">
			<Header title={_('Spremi')} />
			<Body><MoveToCampaign /></Body>
		</Modal>

		<Modal show="edit-folder" hide="rename-folder" className="edit-folder">
			<Header title={_('Promijeni naziv')} />
			<Body><EditCampaign /></Body>
		</Modal>

		<Modal show="confirm-delete-campaign" hide="delete-campaign" className="delete-folder">
			<Header title={_('Obriši mapu')} />
			<Body><DeleteCampaign /></Body>
		</Modal>

		<Modal show="show-add-campaign" hide="hide-add-campaign" className="add-campaign">
			<Header title={_('Nova mapa')} />
			<Body><AddCampaign /></Body>
		</Modal>

		<Modal show="show-message" hide="hide-message" className="message-folder">
			<Header title={_('Obavijest')} />
			<Body><Move /></Body>
		</Modal>

		<Modal show="create-map-for-user" hide="hide-map-for-user" className="create-for-user">
			<Header title={_('Kreiraj mapu za korisnika')} />
			<Body><CreateForUser /></Body>
		</Modal>
	</div>;

	ReactDOM.render(modals, document.getElementById('boom-root'));
}

export function trigger(name, data) {
	action(name, data);
}


// WEBPACK FOOTER //
// ./src/index.js